const ROUTES = [
  {
    slug: "makassar-palopo",
    title: "Ekspedisi Makassar Palopo",
    destination: "Palopo",
    moda: "Darat",
    desc: "Layanan ekspedisi Makassar Palopo via jalur darat poros timur untuk barang dagangan UMKM, material toko, dan kebutuhan retail. Armada berangkat berkala dari kantor kami di Jalan Gatot Subroto Baru No 17, Makassar.",
    points: ["Rute darat reguler Makassar – Palopo", "Cocok untuk kiriman retail dan partai UMKM", "Penjemputan barang area Makassar tersedia"],
  },
  {
    slug: "makassar-palu",
    title: "Ekspedisi Makassar Palu",
    destination: "Palu",
    moda: "Darat / Laut",
    desc: "Pengiriman barang Makassar Palu untuk kebutuhan distribusi dagang, material proyek, dan pasokan toko. Tim kami membantu memilih moda paling hemat antara jalur darat lintas Sulawesi atau kargo laut.",
    points: ["Layanan ekspedisi Makassar – Palu", "Opsi darat lintas Sulawesi atau kargo laut", "Melayani muatan retail hingga partai besar"],
  },
  {
    slug: "makassar-manado",
    title: "Ekspedisi Makassar Manado",
    destination: "Manado",
    moda: "Laut / Udara",
    desc: "Ekspedisi Makassar Manado untuk kiriman antarpulau: kontainer, kubikasi (LCL), hingga kargo udara kilat untuk barang bernilai tinggi atau kebutuhan mendesak.",
    points: ["Kargo laut FCL & LCL Makassar – Manado", "Kargo udara prioritas via Sultan Hasanuddin", "Penanganan dokumen pelabuhan dibantu tim kami"],
  },
  {
    slug: "makassar-jayapura",
    title: "Ekspedisi Makassar Jayapura",
    destination: "Jayapura",
    moda: "Laut / Udara",
    desc: "Spesialis kargo Makassar Jayapura untuk pasokan proyek, distributor, dan kebutuhan komersial ke Papua. Pengiriman kontainer dan curah dengan koordinasi jadwal kapal yang jelas.",
    points: ["Rute rutin kargo laut Makassar – Jayapura", "Layanan stuffing, stripping, dan handling pelabuhan", "Cocok untuk pasokan proyek dan distributor"],
  },
  {
    slug: "makassar-sorong",
    title: "Ekspedisi Makassar Sorong",
    destination: "Sorong",
    moda: "Laut / Udara",
    desc: "Pengiriman barang Makassar Sorong via kargo laut dan udara. Melayani muatan kontainer, kubikasi, serta kargo kilat untuk kebutuhan mendesak di Papua Barat.",
    points: ["Kargo laut & udara Makassar – Sorong", "Tarif kubikasi hemat untuk muatan besar", "Konsultasi jadwal kapal terdekat via formulir"],
  },
  {
    slug: "makassar-timika",
    title: "Ekspedisi Makassar Timika",
    destination: "Timika",
    moda: "Laut / Udara",
    desc: "Ekspedisi Makassar Timika untuk logistik proyek, kebutuhan tambang, dan pasokan komersial. Penanganan muatan partai besar dengan SOP muat-bongkar yang ketat.",
    points: ["Rute kargo Makassar – Timika", "Pengalaman penanganan logistik proyek", "Kargo udara untuk barang sensitif waktu"],
  },
  {
    slug: "makassar-parepare",
    title: "Ekspedisi Makassar Parepare",
    destination: "Parepare",
    moda: "Darat",
    desc: "Rute darat harian Makassar Parepare untuk barang dagangan, paket, dan kebutuhan toko. Salah satu rute prioritas dengan jadwal keberangkatan paling sering.",
    points: ["Jadwal darat reguler Makassar – Parepare", "Harga bersaing untuk kiriman rutin", "Penjemputan area Makassar tersedia"],
  },
  {
    slug: "makassar-bone",
    title: "Ekspedisi Makassar Bone",
    destination: "Bone",
    moda: "Darat",
    desc: "Ekspedisi Makassar Bone via jalur darat poros timur untuk distribusi sembako, material bangunan, dan barang dagangan UMKM dengan tarif kompetitif.",
    points: ["Rute darat Makassar – Bone (Watampone)", "Melayani muatan retail dan partai", "Armada box dan bak sesuai jenis barang"],
  },
];

export default ROUTES;
